<template>
    <el-form ref="loginForm" class="login-form" auto-complete="on" label-position="left">
        <div class="title-container">
            <h3 class="title">
                관리자 로그인
            </h3>
        </div>
        <el-form-item>
        <span class="svg-container">
          <i class="el-icon-user-solid"></i>
        </span>
            <el-input
                    name="loginForm"
                    v-model="id"
                    type="text"
                    auto-complete="on"
            />
        </el-form-item>

        <el-form-item >
        <span class="svg-container">
          <i class="el-icon-lock"></i>
        </span>
            <el-input
                    name="mb_password"
                    v-model="password"
                    type="password"
                    auto-complete="on"
                    @keyup.enter.native="userLogin"
            />
            <span class="show-pwd" @click="showPwd">
          <i class="el-icon-view"></i>
        </span>
        </el-form-item>
        <div class="login_find_link_wrap text_center">
        </div>
        <el-button type="primary" style="width:100%;margin-bottom:10px;" @click="userLogin">
            로그인
        </el-button>
    </el-form>
</template>

<script>
    import {loginTokenSet, getTokenObj} from "@/mixins/Auth";
    import MemberValidator from "@/mixins/validators/MemberValidator"
    import VuxAlert from '@/mixins/vux-alert';
    export default {
        name: "LoginComponent",
        mixins: [MemberValidator, VuxAlert],
        components: {
        },
        props: {
        },
        data() {
            return{
                showPwd: false,
                redirect: '/',
            }
        },
        created() {
            this.redirect = (this.$route.query.redirect) ? this.$route.query.redirect : '/';
        },
        mounted() {

        },
        computed: {
        },
        methods:{
            async userLogin() {
                if (!this.$validate(['id', 'password'])) {
                    return;
                }

                let params = {
                    mb_id: this.id,
                    mb_password: this.password,
                    m_type: 'admin'
                }
                try {
                    await this.$api.$auth.login(params).then( (res) =>  {
                         let ret =  res.Data.Result;
                         let result = this.returnLoginTypeAlertTxt(ret.Info.type)
                         if(result === true) {
                             loginTokenSet(ret.List.token);
                             let tokenObj = getTokenObj();
                             if(tokenObj.g_idx != 3) {
                                 this.errorAlert('관리자 계정만 로그인이 가능합니다.')
                                 this.$localStorage.remove('token');
                                 loginTokenSet("");
                                 return false;
                             }
                             this.$router.push(this.redirect);
                         }else{
                             this.errorAlert(result);
                         }
                     })

                }catch (e) {
                    console.log(e);
                }
            },
            returnLoginTypeAlertTxt(type) {
                switch (type) {
                    case 1:
                        return true;
                    case -3:
                        return '해당하는 회원이 없습니다. 아이디를 다시 확인해주세요.';
                    case -100:
                        return '비밀번호가 틀렸습니다. 비밀번호를 다시 확인해주세요.';
                    default:
                        return '아이디와 비밀번호를 다시 입력해주세요.';
                }
            },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
